/**
 * The display name for a value held in csp.legalcontact / csp.nwcontact.
 *
 * Those fields hold the contact's name directly, so ordinarily this is a no-op. It exists
 * for the values that predate that: a CSP saved while these fields stored a contact id holds
 * the base64 of the name - an Xcipio id is the base64 of the record's natural key, which for
 * a contact is its name, the same assumption adaptContactToSubmit relies on when it builds a
 * collection function's contact as `{ id, name: atob(id) }` - and a CSP saved before contacts
 * existed as a dropdown at all holds free text. Either way what the user sees is a name.
 */
export default function decodeContactValue(value?: string | null): string {
  if (!value) {
    return '';
  }

  try {
    const decoded = window.atob(value);

    // atob accepts anything whose length works out, so a short name can "decode" to
    // mojibake. Only take the result when it is plain printable text.
    return /^[\x20-\x7E]+$/.test(decoded) ? decoded : value;
  } catch {
    return value;
  }
}
